export default __webpack_public_path__ + "static/Dont-Align-buttons-bottom-right-2118b205112167fd34275afcac13f050.png";